import userApi from '@/api/user'
import { errorHandler } from '../exports/error_management'
import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-users-key'
const state = {
    all_users: [],
    drivers: [],
    users: [],
    user: {},
    pagination: null,
    filters : null,
    user_filter : null,
  
}

const getters = {
    all_admin_users(state) {
        return state.all_users.filter(x => !x.is_customer_user)
    },
    sorted_officers(state) {
        console.log('state.all_users', state.all_users)
        const officers = state.all_users
            .filter(({ is_customer_user }) => !is_customer_user)
            .map(({ id, first_name, last_name }) => ({
                id,
                name: `${first_name || ''} ${last_name || ''}`.trim(),
            }))
            .filter(x => x.name)
        officers.sort((a, b) => {
            if (a.name.toUpperCase() > b.name.toUpperCase()) {
                return 1
            }
            if (a.name.toUpperCase() < b.name.toUpperCase()) {
                return -1
            }
            return 0
        })
        console.log('officers', officers)
        return officers
    },
    all_customers_users(state) {
        return state.all_users.filter(x => !!x.is_customer_user)
    },
}

const mutations = {
    set_user(state, payload) {
        state.user = payload
    },
    set_users(state, payload) {
        state.users = payload
    },
    set_drivers(state, payload) {
        state.drivers = payload
    },
    set_all_users(state, data) {
        console.log('all users', data)
        state.all_users = data
    },
    delete_user(state, id) {
        let index = state.users.findIndex(x => x.id == id)
        state.users.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    SET_FILTERS(state, filters) {
        state.filters = filters;
      },
      SET_USER_FILTERS(state,filter){
        state.user_filter = filter;
      }
}

const actions = {
    fetchDrivers(context) {
        new StorageCache(storageKey).reset()
        return userApi.fetchDriverLocations().then(drivers => {
            console.log('drivers-store', drivers)
            context.commit('set_drivers', drivers)
        })
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await userApi.fetchAll()
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_all_users', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    createUser(context, payload) {
        console.log('payload is ------',payload);
        new StorageCache(storageKey).reset()
        return userApi
            .create(
                payload.firstName,
                payload.lastName,
                payload.email,
                payload.roles,
                payload.permissions,
                payload.password,
                payload.department_name,
                payload.ex_ref_no,
                payload.division,
                payload.customer_id,
               
            )
            .then(res => {
                console.log('users', res)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    createUserExcel(context, payload) {
        console.log('payload is ------',payload);
        new StorageCache(storageKey).reset()
        return userApi
            .createExcel(
                payload.firstName,
                payload.lastName,
                payload.email,
                payload.roles,
                payload.permissions,
                payload.password,
                payload.department_name,
                payload.ex_ref_no,
                payload.division,
                payload.customer_id,
                payload.customer_code,
                payload.disable,
                payload.notification
            )
            .then(res => {
                console.log('users', res)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    fetchUser(context, id) {
        console.log('fetchuser id', id)
        return userApi
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: user },
                    },
                }) => {
                    console.log('fetchuser data', user)
                    //const user = data.success.data
                    context.commit('set_user', user)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    fetchUsers(context, payload) {
        new StorageCache(storageKey).reset()
        return userApi
            .fetchUsers(payload.query, payload.page)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    //context.commit('user_update_info', payload)
                    // console.log(result)
                    //console.log(context)
                    //let pag = result.data.success.data
                    let users = pag.data.map(x => {
                        x.firstName = x.first_name
                        x.lastName = x.last_name
                        delete x.first_name
                        delete x.last_name

                        return x
                    })
                    // console.log(users)
                    context.commit('set_users', users)
                    context.commit('set_pagination', {
                        page: pag.current_page,
                        pageSize: pag.per_page,
                        total: pag.total,
                    })
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    async deleteUser(context, id) {
        new StorageCache(storageKey).reset()
        // Check to see if its hitting this command:
        console.log('Deleting user ...')
        return userApi
            .deleteUser(id)
            .then(() => {
                console.log('user deleted')
                context.commit('delete_user', id)
            })
            .catch(err => {
                console.error(err)
                errorHandler(err)
            })
    },
    updateBasicInfo(context, payload) {

        console.log('payload is---------',payload);
        new StorageCache(storageKey).reset()
        console.log('payload', payload)
        return userApi
            .updateBasicInfo(payload)
            .then(() => {
                //context.commit('user_update_info', payload)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    updateEmail(context, payload) {
        new StorageCache(storageKey).reset()
        return userApi
            .updateEmail(payload.userId, payload.email)
            .then(() => {
                //context.commit('user_update_email', payload)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    updatePassword(context, payload) {
        new StorageCache(storageKey).reset()
        return userApi
            .updatePassword(payload.userId, payload.password)
            .then(() => {
                //context.commit('user_update_email', payload)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    unlockUserAccount(context, payload) {
        return userApi
            .unlockUserAccount(payload.userId, payload.is_locked)
            .then(() => {
                //context.commit('user_update_email', payload)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    updateFirstTiemLogin(context, payload) {
        return userApi
            .updateFirstTiemLogin(payload.userId, payload.is_first_time_login)
            .then(() => {
                //context.commit('user_update_email', payload)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    set_dashboard_filter(context,payload){
        context.commit('SET_FILTERS', payload)
    },
    set_user_filter(context,payload){
        context.commit('SET_USER_FILTERS', payload)
    },
    async ExportExcel(context,payload){
        try {
           
            let query = payload.query || "";
      
            const response = await userApi.exportExcel(query);
            const blob = new Blob([response.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Users.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (err) {
            console.error("Error fetching request:", err);
          }

    },
    async exportExcelCSV(context, {filters_u }) {
        try {
            filters_u = filters_u || '';
        
    
          const response = await userApi.exportExcelCSV(filters_u);
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "users.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
      async fetchUserRole(context,role_id) {

       
        return  await userApi.fetchUserRole(role_id);
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
